import { createSlice } from "@reduxjs/toolkit";

import {
  createTournament,
  createTournamentContest,
  deleteTournament,
  duplicateTournament,
  fetchAllClassicalLastQuestions,
  fetchAllClassicalQuestions,
  fetchAllTournaments,
  fetchAllContests,
  fetchAllUnassignedClassicalQuestions,
  fetchTournamentContests,
  fetchTournamentDetails,
  updateTournament,
  fetchQuestionPoolStats,
  getTournamentContestDetail,
  updateTournamentContest,
  fetchAutomatedTailoredContentLearningPoints,
  fetchCustomAssignments,
  fetchCustomAssignmentDetails,
  fetchEligibleUsersForCusttomAssignments,
  fetchNonEligibleUsersForCusttomAssignments,
  fetchCustomAssignmentQuestions,
} from "redux/actions/tournaments/tournamentData";

const initialTournamentFormState = {
  roles: [],
  name: "",
  organization: null,
  tournament_id: null,
  start_date: null,
  end_date: null,
  created_at: null,
  assignment_type: "ORG",
  tournament_type: "",
  tournament_state: "",
  questions_per_contest: 0,
  contest_frequency: "WEEKLY",
  learning_points: [],
  exclude_learning_points: [],
  question_tags: [],
  exclude_question_tags: [],
  version_compatibilities: [],
  errors: [],
  contests_assigned: 0,
  include_all_learning_points: false,
  include_all_question_tags: false,
  selected_timezone: "UTC",
};

const initialContestState = {
  no_of_questions: 0,
  start_date: null,
  end_date: null,
  assignment_type: "ORG",
  question_detail_set: [],
  questionnaire_id: null,
  organization: null,
  group: null,
  clinic: null,
  questions_set: [],
  questionnaire_type: "",
  created_at: null,
  selected_timezone: "UTC",
};

const initialTailoredContest = {
  no_of_questions: 0,
  start_date: null,
  end_date: null,
  assignment_type: "ORG",
  organization: null,
  group: null,
  clinic: null,
  created_at: null,
  selected_timezone: "UTC",
  cadance: "WEEKLY",
  frequency: true,
  score_threshold: 0,
  learning_points: [],
};

const initialState = {
  // API states - Tournament list
  tournamentListLoading: true,
  tournamentList: [],
  tournamentListCount: 0,
  tournamentListPage: 1,
  tournamentListPageSize: 10,

  tournamentDetailLoading: false,
  tournamentDetail: initialTournamentFormState,

  tournamentValidationErrors: {},

  //tailoredContests
  tailoredContestListLoading: false,
  tailoredContestlist: [],
  tailoredContestlistCount: 0,
  tailoredContestlistPage: 1,
  tailoredContestlistPageSize: 10,
  tailoredContestDetailLoading: false,
  tailoredContestDetail: initialTailoredContest,
  tailoredContestValidationErrors: {},
  customAssignmentDetailsLoading: false,
  customAssignmentDetails: [],
  automatedTailoredContentLearningPointsLoading: false,

  //eligible and note eligible for custom assignments
  eligibleUsersForCustomAssignmentsLoading: false,
  eligibleUsersForCustomAssignmentsCount: 0,
  eligibleUsersForCustomAssignmentsPage: 1,
  eligibleUsersForCustomAssignmentsPageSize: 10,
  eligibleUsersForCustomAssignments: [],
  nonEligibleUsersForCustomAssignmentsLoading: false,
  nonEligibleUsersForCustomAssignmentsCount: 0,
  nonEligibleUsersForCustomAssignmentsPage: 1,
  nonEligibleUsersForCustomAssignmentsPageSize: 10,
  nonEligibleUsersForCustomAssignments: [],

  // Create tournament
  tournamentDeleting: false,
  tournamentDuplicating: false,
  tournamentUpdating: false,
  newTournamentCreating: false,
  questionsInPool: null,
  questionExcludedPool: null,

  // Tournament questions
  classicalQuestionsActiveTab: 0,
  classicalQues: [],
  classicalQuesCount: 0,
  classicalQuesPage: 1,
  classicalQuesPageSize: 10,
  classicalQuesLoading: true,
  classicalUnassignedQues: [],
  classicalUnassignedQuesCount: 0,
  classicalUnassignedQuesPage: 1,
  classicalUnassignedQuesPageSize: 10,
  classicalUnassignedQuesLoading: false,
  classicalLastQues: [],
  classicalLastQuesCount: 0,
  classicalLastQuesPage: 1,
  classicalLastQuesPageSize: 10,
  classicalLastQuesLoading: false,
  // Tournament details

  // Tournament contests
  tournamentContestsLoading: true,
  tournamentContests: [],
  tournamentContestsCount: 0,
  tournamentContestsPage: 1,
  tournamentContestsPageSize: 10,

  newContestCreating: false,
  contestCreateStep: 1,
  contestValidationError: {},
  // ContestDetail
  contestDetailLiading: false,
  contestDetail: initialContestState,
  updatingContestDetail: false,

  //contest listing
  contestListLoading: true,
  contestlist: [],
  contestListCount: 0,
  contestListPage: 1,
  contestListPageSize: 10,

  //question listing
  customAssignmentQuestionsLoading: false,
  customAssignmentQuestions: [],
  customAssignmentQuestionsCount: 0,
  customAssignmentQuestionsPage: 1,
  customAssignmentQuestionsPageSize: 10,

  //group andc clinic filter
  selectedCustomAssignmentUserGroups: [],
  selectedCustomAssignmentClinics: [],

  // Filters
  selectedStatusFilter: "",
  selectedTailoredContestStatus: "",
  tailoredContestPage: 1,
  tailoredContestPageSize: 10,
  selectedTournamentTypeFilter: "",
  selectedTournamentNameFilter: "",
  seletedContestTypeFilter: "",
  selectedRoleFilter: [],
  selectedOrgFilter: [],
  selectedStartDateFilter: null,
  selectedEndDateFilter: null,
  selectedAssignmentTypeFilter: "",
  selectedTailoredContestStartDateFilter: null,
  selectedTailoredContestEndDateFilter: null,
  sortOrderBy: "",
  selectedGroup: [],
  selectedClinic: [],
};

export const tournamentSlice = createSlice({
  name: "tournament",
  initialState,
  reducers: {
    resetTournamentDetail: (state) => {
      state.tournamentDetail = initialTournamentFormState;
      state.contestDetail = initialContestState;
      state.contestCreateStep = 1;
      state.tournamentValidationErrors = {};
      (state.tailoredContestDetail = initialTailoredContest),
        (state.tailoredContestValidationErrors = {});
      state.contestValidationError = {};
      state.tournamentContests = [];
      state.tournamentContestsCount = 0;
      state.tournamentContestsPage = 1;
      state.tournamentContestsPageSize = 10;
      (state.questionsInPool = null), (state.questionExcludedPool = null);
    },
    setTournamentDetail: (state, { payload }) => {
      // check if payload key is present in state.tournamentDetail
      Object.keys(payload).forEach((key) => {
        if (key in state.tournamentDetail) {
          state.tournamentDetail[key] = payload[key];
        }
        if (key in state.tournamentValidationErrors) {
          delete state.tournamentValidationErrors[key];
        }
      });
    },
    setContestDetail: (state, { payload }) => {
      Object.keys(payload).forEach((key) => {
        if (key in state.contestDetail) {
          state.contestDetail[key] = payload[key];
        }
        if (key in state.contestValidationError) {
          delete state.contestValidationError[key];
        }
      });
    },

    setTailoredContestDetail: (state, { payload }) => {
      Object.keys(payload).forEach((key) => {
        if (key in state.tailoredContestDetail) {
          state.tailoredContestDetail[key] = payload[key];
        }
        if (key in state.tailoredContestValidationErrors) {
          delete state.tailoredContestValidationErrors[key];
        }
      });
    },
    // Common update
    setTournamentSliceData: (state, { payload }) => {
      if (payload.type && payload.type in state) {
        state[payload.type] = payload.data;
      }
    },

    setContestSliceData: (state, { payload }) => {
      if (payload.type && payload.type in state) {
        state[payload.type] = payload.data;
      }
    },
    // Create tournament
    resetCreateData: (state) => {
      state.tournamentDetail = initialTournamentFormState;
      state.contestDetail = initialContestState;
      state.contestCreateStep = 1;
      state.tournamentValidationErrors = {};
      state.contestValidationError = {};
      state.classicalQuestionsActiveTab = 0;
      state.classicalQues = [];
      state.classicalQuesCount = 0;
      state.classicalQuesPage = 1;
      state.classicalQuesPageSize = 10;
      state.classicalQuesLoading = true;
      state.classicalUnassignedQues = [];
      state.classicalUnassignedQuesCount = 0;
      state.classicalUnassignedQuesPage = 1;
      state.classicalUnassignedQuesPageSize = 10;
      state.classicalUnassignedQuesLoading = false;
      state.classicalLastQues = [];
      state.classicalLastQuesCount = 0;
      state.classicalLastQuesPage = 1;
      state.classicalLastQuesPageSize = 10;
      state.classicalLastQuesLoading = false;
      state.tournamentContests = [];
      state.tournamentContestsCount = 0;
      state.tournamentContestsPage = 1;
      state.tournamentContestsPageSize = 10;
    },
    toggleModCreateQuesSelect: (state, { payload }) => {
      const contestDetail = state.contestDetail;
      if (!payload && !payload.question_id) {
        return;
      }
      if (contestDetail.questions_set.includes(payload.question_id)) {
        const questions_set = contestDetail.questions_set.filter(
          (item) => item !== payload.question_id
        );
        state.contestDetail.questions_set = questions_set;
        const question_detail_set = contestDetail.question_detail_set.filter(
          (item) => item.question_id !== payload.question_id
        );
        state.contestDetail.question_detail_set = question_detail_set;
      } else {
        state.contestDetail.questions_set.push(payload.question_id);
        state.contestDetail.question_detail_set.push(payload);
      }
    },
  },
  extraReducers: {
    // All category list
    [fetchAllContests.pending]: (state) => {
      state.contestListLoading = true;
    },
    [fetchAllContests.fulfilled]: (state, { payload }) => {
      state.contestList = payload?.results ? payload.results : [];
      state.contestListCount = payload?.count ? payload.count : 0;
      state.contestListLoading = false;
    },
    [fetchAllContests.rejected]: (state) => {
      state.contestListLoading = false;
    },

    [fetchAllTournaments.pending]: (state) => {
      state.tournamentListLoading = true;
    },
    [fetchAllTournaments.fulfilled]: (state, { payload }) => {
      state.tournamentList = payload?.results ? payload.results : [];
      state.tournamentListCount = payload?.count ? payload.count : 0;
      state.tournamentListLoading = false;
    },
    [fetchAllTournaments.rejected]: (state) => {
      state.tournamentListLoading = false;
    },
    [fetchTournamentDetails.pending]: (state) => {
      state.tournamentDetailLoading = true;
    },
    [fetchTournamentDetails.fulfilled]: (state, { payload }) => {
      state.tournamentDetail = payload ? payload : initialTournamentFormState;
      state.tournamentDetailLoading = false;
    },
    [fetchTournamentDetails.rejected]: (state) => {
      state.tournamentDetailLoading = false;
    },
    [fetchTournamentContests.pending]: (state) => {
      state.tournamentContestsLoading = true;
    },
    [fetchTournamentContests.fulfilled]: (state, { payload }) => {
      state.tournamentContests = payload?.results ? payload.results : [];
      state.tournamentContestsCount = payload?.count ? payload.count : 0;
      state.tournamentContestsLoading = false;
    },
    [fetchTournamentContests.rejected]: (state) => {
      state.tournamentContestsLoading = false;
    },
    [fetchAllClassicalQuestions.pending]: (state) => {
      state.classicalQuesLoading = true;
    },
    [fetchAllClassicalQuestions.fulfilled]: (state, { payload }) => {
      state.classicalQues = payload?.results;
      state.classicalQuesCount = payload?.count ? payload.count : 0;
      state.classicalQuesLoading = false;
    },
    [fetchAllClassicalQuestions.rejected]: (state) => {
      state.classicalQuesLoading = false;
    },
    [fetchAllUnassignedClassicalQuestions.pending]: (state) => {
      state.classicalUnassignedQuesLoading = true;
    },
    [fetchAllUnassignedClassicalQuestions.fulfilled]: (state, { payload }) => {
      state.classicalUnassignedQues = payload?.results;
      state.classicalUnassignedQuesCount = payload?.count ? payload.count : 0;
      state.classicalUnassignedQuesLoading = false;
    },
    [fetchAllUnassignedClassicalQuestions.rejected]: (state) => {
      state.classicalUnassignedQuesLoading = false;
    },
    [fetchAllClassicalLastQuestions.pending]: (state) => {
      state.classicalLastQuesLoading = true;
    },
    [fetchAllClassicalLastQuestions.fulfilled]: (state, { payload }) => {
      state.classicalLastQues = payload?.results;
      state.classicalLastQuesCount = payload?.count ? payload.count : 0;
      state.classicalLastQuesLoading = false;
    },
    [fetchAllClassicalLastQuestions.rejected]: (state) => {
      state.classicalLastQuesLoading = false;
    },
    [createTournament.pending]: (state) => {
      state.newTournamentCreating = true;
    },
    [createTournament.fulfilled]: (state) => {
      state.newTournamentCreating = false;
    },
    [createTournament.rejected]: (state, { payload }) => {
      state.newTournamentCreating = false;
      state.tournamentValidationErrors = payload ? payload : {};
    },
    [createTournamentContest.pending]: (state) => {
      state.newContestCreating = true;
    },
    [createTournamentContest.fulfilled]: (state) => {
      state.newContestCreating = false;
    },
    [createTournamentContest.rejected]: (state) => {
      state.newContestCreating = false;
    },
    // Tournament delete
    [deleteTournament.pending]: (state) => {
      state.tournamentDeleting = true;
    },
    [deleteTournament.fulfilled]: (state) => {
      state.tournamentDeleting = false;
    },
    [deleteTournament.rejected]: (state) => {
      state.tournamentDeleting = false;
    },
    // Tournament duplicate
    [duplicateTournament.pending]: (state) => {
      state.tournamentDuplicating = true;
    },
    [duplicateTournament.fulfilled]: (state) => {
      state.tournamentDuplicating = false;
    },
    [duplicateTournament.rejected]: (state) => {
      state.tournamentDuplicating = false;
    },
    // Tournament update
    [updateTournament.pending]: (state) => {
      state.tournamentUpdating = true;
    },
    [updateTournament.fulfilled]: (state) => {
      state.tournamentUpdating = false;
    },
    [updateTournament.rejected]: (state, { payload }) => {
      state.tournamentUpdating = false;
      state.tournamentValidationErrors = payload ? payload : {};
    },
    [fetchQuestionPoolStats.fulfilled]: (state, { payload }) => {
      if (payload.type === "included") {
        state.questionsInPool = payload.total_questions;
      }
      if (payload.type === "excluded") {
        state.questionExcludedPool = payload.total_questions;
      }
    },
    [getTournamentContestDetail.pending]: (state) => {
      state.contestDetailLiading = true;
    },
    [getTournamentContestDetail.fulfilled]: (state, { payload }) => {
      state.contestDetail = payload ? payload : initialContestState;
      state.contestDetailLiading = false;
    },
    [getTournamentContestDetail.rejected]: (state) => {
      state.contestDetailLiading = false;
    },
    [updateTournamentContest.pending]: (state) => {
      state.updatingContestDetail = true;
    },
    [updateTournamentContest.fulfilled]: (state, { payload }) => {
      state.updatingContestDetail = false;
      state.contestDetail = payload;
    },
    [updateTournamentContest.rejected]: (state) => {
      state.updatingContestDetail = false;
    },
    [fetchAutomatedTailoredContentLearningPoints.pending]: (state) => {
      state.automatedTailoredContentLearningPointsLoading = true;
    },
    [fetchAutomatedTailoredContentLearningPoints.fulfilled]: (
      state,
      { payload }
    ) => {
      state.tailoredContestDetail.learning_points = payload.results;
      state.automatedTailoredContentLearningPointsLoading = false;
    },
    [fetchAutomatedTailoredContentLearningPoints.rejected]: (state) => {
      state.automatedTailoredContentLearningPointsLoading = false;
      state.tailoredContestDetail.learning_points = [];
    },
    [fetchCustomAssignments.pending]: (state) => {
      state.tailoredContestListLoading = true;
    },
    [fetchCustomAssignments.fulfilled]: (state, { payload }) => {
      state.tailoredContestlist = payload.results;
      state.tailoredContestListCount = payload.count ? payload.count : 0;
      state.tailoredContestListLoading = false;
    },
    [fetchCustomAssignments.rejected]: (state) => {
      state.tailoredContestListLoading = false;
      state.tailoredContestlist = [];
    },
    [fetchCustomAssignmentDetails.pending]: (state) => {
      state.customAssignmentDetailsLoading = true;
    },
    [fetchCustomAssignmentDetails.fulfilled]: (state, { payload }) => {
      state.customAssignmentDetails = payload;
      state.customAssignmentDetailsLoading = false;
    },
    [fetchCustomAssignmentDetails.rejected]: (state) => {
      state.customAssignmentDetailsLoading = false;
    },
    [fetchEligibleUsersForCusttomAssignments.pending]: (state) => {
      state.eligibleUsersForCustomAssignmentsLoading = true;
    },
    [fetchEligibleUsersForCusttomAssignments.fulfilled]: (
      state,
      { payload }
    ) => {
      state.eligibleUsersForCustomAssignments = payload;
      state.eligibleUsersForCustomAssignmentsCount = payload.count;
      state.eligibleUsersForCustomAssignmentsLoading = false;
    },
    [fetchEligibleUsersForCusttomAssignments.rejected]: (state) => {
      state.eligibleUsersForCustomAssignmentsLoading = false;
    },
    [fetchNonEligibleUsersForCusttomAssignments.pending]: (state) => {
      state.nonEligibleUsersForCustomAssignmentsLoading = true;
    },
    [fetchNonEligibleUsersForCusttomAssignments.fulfilled]: (
      state,
      { payload }
    ) => {
      state.nonEligibleUsersForCustomAssignments = payload;
      state.nonEligibleUsersForCustomAssignmentsCount = payload.count;
      state.nonEligibleUsersForCustomAssignmentsLoading = false;
    },
    [fetchNonEligibleUsersForCusttomAssignments.rejected]: (state) => {
      state.nonEligibleUsersForCustomAssignmentsLoading = false;
    },
    [fetchCustomAssignmentQuestions.pending]: (state) => {
      state.customAssignmentQuestionsLoading = true;
    },
    [fetchCustomAssignmentQuestions.fulfilled]: (state, { payload }) => {
      state.customAssignmentQuestions = payload.results;
      state.customAssignmentQuestionsCount = payload.count;
      state.customAssignmentQuestionsLoading = false;
    },
    [fetchCustomAssignmentQuestions.rejected]: (state) => {
      state.customAssignmentQuestionsLoading = false;
    },
  },
});

export const {
  setContestSliceData,
  setTournamentSliceData,
  resetCreateData,
  toggleModCreateQuesSelect,
  resetTournamentDetail,
  setTournamentDetail,
  setTailoredContestDetail,
  setContestDetail,
} = tournamentSlice.actions;

export default tournamentSlice.reducer;
